export function removeQueryParam (param: string): void {
  const url = new URL(window.location.href)
  url.searchParams.delete(param)
  window.history.replaceState({}, document.title, url.toString())
}
